import { useQuery, useMutation } from '@apollo/client';

import GET_TOASTS from '../graphql/getToasts';
import PUSH_TOAST from '../graphql/pushToast';
import POP_TOAST from '../graphql/popToast';
import {
  Mutation,
  PushToastMutationVariables,
  Query,
} from '../../../generated/gql';
import { useApolloClientsContext } from '../../../providers/ApolloClientsProvider';

export const useToasts = () => {
  const { clients } = useApolloClientsContext();
  if (!clients.community) {
    throw new Error(
      'The community client is not configured, this is required for toasts to not work',
    );
  }

  const { data } = useQuery<Query>(GET_TOASTS, { client: clients.community });
  const [pushToast] = useMutation<Mutation, PushToastMutationVariables>(
    PUSH_TOAST,
    { client: clients.community },
  );
  const [popToast] = useMutation<Mutation>(POP_TOAST, {
    client: clients.community,
  });

  return { toasts: data?.toasts, pushToast, popToast };
};
